export { CoreCurrentLangService } from './core-current-lang.service';
export { CoreGetLangsService } from './core-get-langs.service';
export * from './lang.types';
